import { getPrograma,update } from "../index";
import { Subcriptores as Subs } from '../../../Suscripciones';
export default function Subcriptores() {
    const p = getPrograma();
    return <Subs s={p.suscriptores} u={update} />
}